import React from "react";
import ImageComponent from "../Image/ImageComponent";

function HowItWorksInfoCard({ icon, title, description }) {
  return (
    <div className="flex flex-col items-center text-center space-y-4">
      <ImageComponent src={icon} alt={"icon"} className={"w-32"} />
      <h3 className="text-lg font-bold text-[#0b3d2c]">{title}</h3>
      <p className="text-sm text-[#777777]">{description}</p>
    </div>
  );
}

export default HowItWorksInfoCard;
